<div  [hidden]="!loadingprogress" class="w3-modal">
    <div class="w3-modal-content">
    <img style="
       width: 100%; 
       height: 100%;" src="assets/img/giphy2.gif">
    </div>
</div>
<!-- <div [hidden]="!loadingprogress" class="fixed inset-0 z-50 hidden items-center justify-center bg-black bg-opacity-40">
    <div class="relative bg-white rounded-lg shadow-lg mx-auto w-4/5 animate-fade-in">
        <img class="w-full h-full object-cover" src="images/giphy2.gif" alt="Loading...">
    </div>
</div> -->
